// import logo from './logo.svg';
// import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import Autosuggest from "react-autosuggest";
import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";

const SearchOrganizationalUnit = (props) => {
  const [data, setData] = useState([]);
  const [unidad, setUnidad] = useState([]);
  const [value, setValue] = useState(
    // props.unidad_organizativa ? props.list_unidad_organizativa[0].nombre : ""
    props.label
  );
  const [timer, setTimer] = useState(null);
  const dispatch = useDispatch();

  const onSuggestionsFetchRequested = ({ value }) => {
    // console.log("value", value);
    //timer para que la api no se dispare por cada letra sino hasta que el usuario termine de escribir
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        obtenerData(value);
      }, 2000)
    );
  };

  const onSuggestionsClearRequested = () => {
    setUnidad([]);
  };

  const getSuggestionValue = (suggestion) => {
    return `${suggestion.codigo ? suggestion.codigo : ""} / ${
      suggestion.nombre
    }`;
  };

  //sugerencias del input
  const renderSuggestion = (suggestion) => (
    <div className="sugerencia" onClick={() => seleccionarUnidad(suggestion)}>
      {`${suggestion.codigo ? suggestion.codigo : ""} / ${suggestion.nombre}`}
    </div>
  );

  const seleccionarUnidad = (field) => {
    props.setFieldValue(props.name, JSON.stringify(field));
    // props.setUnidadSeleccionado(field);
  };

  const onChange = (e, { newValue }) => {
    setValue(newValue);
  };

  //Input
  const inputProps = {
    className: "form-control rounded-pill ",
    placeholder: `${props.placeholder}${
      props.tipoBusqueda ? ": Búsqueda por " : ""
    }${props.tipoBusqueda ? props.tipoBusqueda.desc : ""}`,
    value,
    onChange,
  };

  const obtenerData = async (value) => {
    props.getFuncionalAreas(value);
  };

  return (
    <div className="App">
      <Autosuggest
        suggestions={props.areas ? props.areas : props.employees}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
        // onSuggestionSelected={eventEnter}
      />
      <br />
    </div>
  );
};

export default SearchOrganizationalUnit;
